import React from 'react';

import { AppPermissionsPropTypes } from 'src/pages/App/propTypes';
import { compactPermissions } from 'src/utils/data/permission';
import { CurrentUserMetaProvider } from 'src/utils/context/CurrentUserMetaContext';
import { CurrentUserMetaReloadProvider } from 'src/utils/context/CurrentUserMetaReloadContext';
import { CurrentUserPermissionsProvider } from 'src/utils/context/CurrentUserPermissionsContext';
import { CurrentUserProvider } from 'src/utils/context/CurrentUserContext';
import { useCurrentUserMeta } from 'src/hooks/currentUserMeta';
import * as Sentry from "@sentry/browser";
import getEnv from 'src/utils/api/env';

export const AppPermissions = ({ authorized, children, currentUser }) => {

  const devEnviorment = ['STAGING', 'DEV', 'PROD', 'ONBOARD'];
  const envCatch = getEnv();
  if ( devEnviorment.includes(envCatch) ) {
    Sentry.setUser({ 'email' : currentUser.data.email });
  }

  const permissions = {
    compact: compactPermissions(currentUser.permissions),
    loading: currentUser.isLoading.permissions,
    permissions: currentUser.permissions,
  };

  const {
    data: currentUserMetaData,
    refetch: refetchCurrentUserMetaData,
  } = useCurrentUserMeta(!authorized);

  const currentUserMeta = {};
  ((currentUserMetaData || {}).currentUserMeta || []).forEach(
    ({ key, value }) => {
      currentUserMeta[key] = value;
    },
  );

  return (
    <CurrentUserMetaReloadProvider value={refetchCurrentUserMetaData}>
      <CurrentUserMetaProvider value={currentUserMeta}>
        <CurrentUserProvider value={currentUser.data}>
          <CurrentUserPermissionsProvider value={permissions}>
            {children}
          </CurrentUserPermissionsProvider>
        </CurrentUserProvider>
      </CurrentUserMetaProvider>
    </CurrentUserMetaReloadProvider>
  );
};

AppPermissions.propTypes = AppPermissionsPropTypes;
